module.exports = __webpack_public_path__ + "static/media/plus-white.e19ec114.svg";